// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const globalVars = {
    stickyVerticalTopOffset: '--awsui-sticky-vertical-top-offset',
    stickyVerticalBottomOffset: '--awsui-sticky-vertical-bottom-offset',
};
export default globalVars;
//# sourceMappingURL=global-vars.js.map